/**
 * Конвейер обработки списка middleware маршрутов
 */
function middlewarePipeline(context: { to: any, from: any, next: any, }, middleware: any[], index: number) {

  const nextMiddleware = middleware[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return () => {
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);
    nextMiddleware({...context, next: nextPipeline});
  }
}

export default middlewarePipeline;
